import WaitlistForm from "./WaitlistForm";
import Reveal from "./Reveal";

export default function FinalCTA() {
  return (
    <section id="waitlist" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2.5rem] p-[1.5px]" data-testid="final-cta-card">
            <div
              className="absolute inset-0 rounded-[2.5rem] bg-[conic-gradient(from_0deg,#8c52ff,#42f68f,#f4c138,#2b0086,#8c52ff)] opacity-60 [background-size:300%_300%] animate-[border-trace_9s_ease_infinite]"
              aria-hidden="true"
            />
            <div className="relative overflow-hidden rounded-[2.35rem] bg-gradient-to-b from-[#12062b] to-[#0a0612] px-6 py-16 text-center sm:px-12 lg:py-24">
              <div
                className="pointer-events-none absolute left-1/2 top-0 h-[340px] w-[680px] -translate-x-1/2 rounded-full bg-brand-purple opacity-25 blur-[130px]"
                aria-hidden="true"
              />
              <div className="relative">
                <span className="inline-block rounded-full border border-brand-gold/40 bg-brand-gold/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.22em] text-brand-gold">
                  Boston beta · Early access
                </span>
                <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
                  Don't miss the <span className="text-gradient">first drop.</span>
                </h2>
                <p className="mx-auto mt-5 max-w-xl text-brand-mist/70">
                  Join the waitlist for early access to Lantix and be first in line when the
                  Boston beta goes live.
                </p>
                <div className="mx-auto mt-9 max-w-lg" data-testid="final-waitlist-form">
                  <WaitlistForm idPrefix="final-waitlist" source="final-cta" />
                </div>
                <p className="mt-6 text-sm text-brand-mist/50">
                  Production companies &amp; venues:{" "}
                  <a
                    href="mailto:hello@lantixapp.com"
                    data-testid="final-cta-promoter-link"
                    className="font-semibold text-brand-teal transition-colors hover:text-brand-gold"
                  >
                    hello@lantixapp.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
